/** Normalize load list rows for EntityGridPro (ticket # display + filter field). */
export function mapLoadGridRows(items) {
    return (items ?? []).map((item) => {
        if (!item) return item;

        const ticketDisplay =
            item.load?.ticketNumberOrId ??
            item.load?.ticketNumber ??
            item.loadId ??
            null;

        return {
            ...item,
            load: item.load
                ? { ...item.load, ticketNumber: ticketDisplay }
                : item.load,
        };
    });
}
